import { useState } from "react"
import { useData } from "./hooks/data"
import { useListaEsperaView } from "./hooks/useListaEsperaView"
import { buildDisponibilidadSlides, buildListaEsperaSlides } from "./utils/slideBuilders"
import CarouselGroup from "./components/carousel-group"
import NoticesSection from "./components/notices-section/NoticesSection"
import Turno from "./components/turno/Turno"
import "./Disponibilidad.css"

function Disponibilidad(): JSX.Element {
    const { loading, logo, items, img_promo_horizontal, img_promo_vertical, lista_espera, folio_turn } = useData()
    const { isOpen: openListaEspera, openWindow: abrirListaEspera } = useListaEsperaView()
    const [activeSlide, setActiveSlide] = useState(1)

    const disponibilidadSlides = buildDisponibilidadSlides({ items, logo })

    const listaEsperaSlides = !openListaEspera
        ? buildListaEsperaSlides({
            listaEspera: lista_espera,
            onListaEsperaTitleClick: abrirListaEspera,
            showExternalLinkIcon:true,
        })
        : []

    const allSlides = [...disponibilidadSlides, ...listaEsperaSlides]

    const shouldShowListaEsperaTitleInNotices =
        !openListaEspera &&
        activeSlide > items.length

    return (
        <div className="disp__screen">
            <div className="disp__content">
                <div className="disp__card-section">
                    <CarouselGroup 
                        key={openListaEspera ? "abierta" : "cerrada"} 
                        onPageChange={setActiveSlide}
                    >
                        {allSlides}
                    </CarouselGroup>
                </div>

                <NoticesSection
                    logo={logo}
                    loading={loading}
                    imgPromoH={img_promo_horizontal}
                    imgPromoV={img_promo_vertical}
                    showListaEsperaTitle={shouldShowListaEsperaTitleInNotices}
                    onListaEsperaTitleClick={abrirListaEspera}
                    showExternalLinkIcon={shouldShowListaEsperaTitleInNotices}
                    folioTurn={folio_turn}
                />

                {!openListaEspera && (
                    <Turno 
                        folioTurno={folio_turn} 
                        size="large" 
                        showDuration={10000} 
                        isModal={true}
                    >
                        <span>Pregunta al personal por tu habitación.</span>
                    </Turno>
                )}
            </div>
        </div>
    )
}

export default Disponibilidad